import { render, staticRenderFns } from "./consignmenttracking.vue?vue&type=template&id=be21bdf6&"
import script from "./consignmenttracking.vue?vue&type=script&lang=js&"
export * from "./consignmenttracking.vue?vue&type=script&lang=js&"
import style0 from "./consignmenttracking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports